import { computed } from 'vue';
import { useRoute } from '#imports';
import {
  SEARCH_RETURN_COUNT_PARAM,
  SEARCH_RETURN_PAGE_PARAM,
  SEARCH_RETURN_QUERY_PARAM,
  SEARCH_RETURN_TYPE_PARAM,
} from '~/composables/use-search-result-url';
import { getFirstQueryParam } from '~/utils/common';

/**
 * Reads the `from_search*` query params a search result card appends when it
 * navigates away, so detail pages (content, store, learning) can show the
 * "Search: \"query\" • n results" pill and send the user back to the exact
 * results page they came from.
 */
export const useSearchReturn = () => {
  const route = useRoute();

  const searchQuery = computed(() =>
    getFirstQueryParam(route.query[SEARCH_RETURN_QUERY_PARAM]),
  );
  const resultsCount = computed(() =>
    getFirstQueryParam(route.query[SEARCH_RETURN_COUNT_PARAM]),
  );

  const returnUrl = computed(() => {
    if (!searchQuery.value) return null;
    const params = new URLSearchParams({ query: searchQuery.value });
    const type = getFirstQueryParam(route.query[SEARCH_RETURN_TYPE_PARAM]);
    const page = getFirstQueryParam(route.query[SEARCH_RETURN_PAGE_PARAM]);
    if (type) params.set('type', type);
    if (page) params.set('page', page);
    return `/search?${params.toString()}`;
  });

  return { searchQuery, resultsCount, returnUrl };
};
